import React, { FocusEventHandler, useState } from "react";
import { InputBaseProps } from "..";
import { SanityInputDropdownProps } from "../../../models/form/SanityFormInputField";
import ControlledSelect from "../../ControlledInputs/ControlledSelect";
import { Inputs } from "../Inputs";
import { useFieldValidator } from "../Validation";
import { renderHiddenOptionValues } from "./DynamicInputs";
import InputContainer from "./InputContainer";
import { useFieldCustom } from "./useFieldCustom";

export type SelectProps = InputBaseProps<SanityInputDropdownProps>;

const Select = (props: SelectProps) => {
  const { name, label, options, placeholder, readonly, validation } = props;

  const validator = useFieldValidator(validation);
  const [field, meta] = useFieldCustom({
    name,
    validate: validator
  });

  const [focused, setFocused] = useState(false);

  const onFocus: FocusEventHandler<HTMLSelectElement> = () => {
    setFocused(true);
  };

  const onBlur: FocusEventHandler<HTMLSelectElement> = e => {
    field.onBlur(e);
    setFocused(false);
  };

  const optionsWithSubfields = options.filter(option => option.inputs?.length);
  const selectedOptionsWithSubfields = optionsWithSubfields.filter(
    option => option.value === meta.value
  );
  const notSelectedOptionsWithSubfields = optionsWithSubfields.filter(
    option => option.value !== meta.value
  );

  return (
    <>
      <InputContainer meta={meta}>
        <ControlledSelect
          {...field}
          error={meta.touched && !!meta.error}
          focused={focused}
          id={name}
          label={label}
          onBlur={onBlur}
          onFocus={onFocus}
          options={[
            {
              title: placeholder ?? "",
              value: ""
            },
            ...options.map(option => ({
              title: option.label ?? option.value,
              value: option.value
            }))
          ]}
          readonly={readonly}
          value={meta.value}
        />
      </InputContainer>

      {!!selectedOptionsWithSubfields.length && (
        <div className="border-l border-input-border pl-4">
          {selectedOptionsWithSubfields.map((option, index) => (
            <Inputs
              inputs={option.inputs ?? []}
              key={index}
              readonly={readonly ?? false}
            />
          ))}
        </div>
      )}

      {!!notSelectedOptionsWithSubfields.length &&
        renderHiddenOptionValues(notSelectedOptionsWithSubfields)}
    </>
  );
};

export default Select;
